import { render, staticRenderFns } from "./UncommissionedDevices.vue?vue&type=template&id=ee81f172&"
import script from "./UncommissionedDevices.vue?vue&type=script&lang=ts&"
export * from "./UncommissionedDevices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports